<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0; padding-top: 10px">
      <v-row class="text-start">
        <v-col md="12">
          <v-card flat class="text-right v-card-bg-none">
            <v-card-actions>
              <v-btn color="secondary" outlined class="mr-1" to="/courses">
                <v-icon class="mr-1" small>fa-chevron-left</v-icon> Back to
                Course List
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="loading" fluid class="pt-8">
      <v-row justify="center" align="center">
        <v-col align="center" class="pa-0 col-md-10 col-sm-10 col-xs-12">
          <div class="course-title-wrapper mb-4">
            <div class="course-title skeleton-box" style="width: 100%; height: 16px;"></div>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col align="center" class="pa-0 col-md-6 col-sm-6 col-xs-12">
          <v-list-item v-for="index in 3" :key="index">
            <div class="course-description skeleton-box" style="width: 100%; height: 16px;"></div>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col md="10">
          <div>
            <div class="course-duration">
              Duration:
              <div class="course-description skeleton-box" style="width: 100%; height: 16px;"></div>
            </div>
            <div class="course-status">
              Status:<div class="course-description skeleton-box" style="width: 100%; height: 16px;"></div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col class="col-md-8 col-sm-8 col-xs-8">
          <v-skeleton-loader class="mx-auto border" type="image"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col md="8" align="left">
          <v-skeleton-loader class="mx-auto" type="heading"></v-skeleton-loader>
          <v-skeleton-loader class="mx-auto mt-5" type="sentences"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" class="mb-5">
        <v-col md="8">
          <h2 class="mb-2 font-20">Course Content</h2>
          <v-list-item style="border: 1px solid #ccc;">
            <div class="skeleton-box" style="width: 50px; height: 24px;"></div>
            <div class="skeleton-box ml-5" style="width: 50px; height: 24px;"></div>
          </v-list-item>
          <v-list-item v-for="index in 4" :key="index" style="border: 1px solid #ccc;">
            <div class="skeleton-box notification-state-box" style="width: 25px; height: 24px;"></div>
            <div class="skeleton-box notification-state-box" style="width: 25px; height: 24px;"></div>
            <v-list-item-content>
              <div class="skeleton-box" style="width: 70%; height: 16px;"></div>
            </v-list-item-content>
            <v-list-item-action style="align-items: center;">
              <div class="skeleton-box" style="width: 60px; height: 30px;"></div>
            </v-list-item-action>
          </v-list-item>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else-if="noCourseFound" fluid class="pt-8">
      <h2>No Courses Found</h2>
      <v-text label="Testing" v-if="showAdmin">
        <a href="#/admin/courses">Click here to access the Course List</a>
      </v-text>
    </v-container>
    <v-container fluid v-else>
      <v-row justify="center" align="center">
        <v-col align="center" class="pa-0 col-md-10 col-sm-10 col-xs-12">
          <div class="course-title-wrapper">
            <p class="course-title">
              {{ course.name }}
            </p>
            <v-tooltip v-if="course.is_membership" bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on" class='isMember-Title'></div>
              </template>
              <span>Membership Content</span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col align="center" class="pa-0 col-md-6 col-sm-6 col-xs-12">
          <!-- <div v-for="(text, index) in course.description.split('\\n')" :key="index" class="course-description">
            <ul v-if="text.includes('•')" v-bind:style="{ listStyleType: text.includes('\\t') ? 'none' : '' }">
              <li>
                <p style="margin: 0;">
                  <span><ul v-if="text.includes('\\t')"> <li>{{ text.replace('\\t•', '') }} </li></ul><div v-else>{{ text.replace('•', '') }}<br></div></span>
                </p>
              </li>
            </ul>
            <div v-else>{{ text }}<br></div>
          </div> -->
          <div class="course-description" @click="handleLinkClick" v-html="course.description"></div>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col class="col-md-10 col-sm-12 col-xs-12">
          <div>
            <div class="course-duration">Duration: {{ duration }} mins</div>
            <div class="course-status">
              Status:
              <div v-if="inProgress">Progress: {{ user.progress }}%</div>
              <div v-if="notStarted">Enrolled</div>
              <div v-if="complete">Completed</div>
              <div v-if="completeWithOutTest">Complete Test</div>
              <!--{{course.enrolled.data.state_text}}-->
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col class="col-md-8 col-sm-8 col-xs-8" align="center" v-if="hasVideos">
          <VideoPlayer />
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="selectedVideo">
        <v-col md="8" align="left" :class="[(hasTest || complete) ? 'mb-10' : '']">
          <h2>{{ selectedVideo.title }}</h2>
          <p class="video-item-description">{{ selectedVideo.description }}</p>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="isPpt">
        <PptPlayer />
      </v-row>
      <v-row justify="center" align="center" style="margin-bottom: 70px;" v-if="isScorm">
        <ScormPlayer :courseUserId="this.$store.getters.userStats.id" />
      </v-row>
      <v-row justify="center" align="center" v-if="hasTest || complete">
        <v-col md="8" class="test-section mb-10">
          <v-card v-if="hasTest && !complete" flat style="width: 100%" class="text-xs-center">
            <div v-if="user.test_complete">
              <div v-if="user.test_passed" style="
                  background-color: #f8b464;
                  border-radius: 4px;
                  padding: 0 22px 0 22px;
                ">
                <!-- Small Screen -->
                <v-row v-if="this.screenSize === 'mobile'">
                  <v-col style="padding-top: 0; padding-bottom: 0">
                    <div style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 1rem;
                      ">
                      <v-btn icon>
                        <img src="/static/test-passed-icon.png" />
                      </v-btn>

                      <div class="congratulation-txt">
                        Congratulations, you’ve completed this course
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="this.screenSize === 'mobile'">
                  <v-col style="
                      display: flex;
                      justify-content: center;
                      padding-top: 0;
                    ">
                    <v-btn class="download-certificate-btn download-certificate-txt" text style="float: right"
                      @click="downloadCertificate">
                      Download Certificate
                    </v-btn>
                  </v-col>
                </v-row>

                <!-- Medium and Large Screen -->
                <v-card-actions class="pa-0" v-if="
                    this.screenSize === 'desktop' ||
                    this.screenSize === 'tablet'
                  ">
                  <v-col cols="1" class="pr-0">
                    <v-btn icon>
                      <img src="/static/test-passed-icon.png" />
                    </v-btn>
                  </v-col>
                  <v-col cols="6" class="pl-0">
                    <v-card-text class="congratulation-txt">
                      <div>Congratulations, you’ve completed this course</div>
                    </v-card-text>
                  </v-col>
                  <v-col cols="5">
                    <v-btn class="download-certificate-btn download-certificate-txt" text style="float: right"
                      @click="downloadCertificate">
                      Download Certificate
                    </v-btn>
                  </v-col>
                </v-card-actions>
              </div>
              <div v-else style="
                  background-color: #3ca1d0;
                  border-radius: 4px;
                  padding: 0 22px 0 22px;
                ">
                <!-- Small Screen -->
                <v-row v-if="this.screenSize === 'mobile'">
                  <v-col style="padding-top: 0; padding-bottom: 0">
                    <div style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 1rem;
                      ">
                      <v-btn icon class="test-start-icon">
                        <img
                          :src="$globalConfig.APP_NAME == 'senso' ? '/static/test-icon-start.png' : '/static/test-icon-start-improve.png'" />
                      </v-btn>

                      <div class="start-test-txt">
                        Test failed. You scored {{ user.test_score }}%
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="this.screenSize === 'mobile'" class="pb-3 pt-3" no-gutters>
                  <v-col style="
                      display: flex;
                      justify-content: center;
                      padding-top: 0;
                      padding-bottom: 0;
                    " class="test-btn-wrapper">
                    <v-btn class="" @click="showTest"> Take test again </v-btn>
                  </v-col>
                  <v-col style="
                      display: flex;
                      justify-content: center;
                      padding-top: 0;
                      padding-bottom: 0;
                    " class="test-btn-wrapper">
                    <v-btn class="" :to="'/courses/test/log/' + id + '/' + user.id">
                      View Result
                    </v-btn>
                  </v-col>
                </v-row>

                <!-- Medium and Large Screen -->
                <v-row v-if="
                    this.screenSize === 'desktop' ||
                    this.screenSize === 'tablet'
                  ">
                  <v-col cols="1" class="pr-0 pl-10" style="display: flex; align-items: center">
                    <v-btn icon class="test-start-icon">
                      <img
                        :src="$globalConfig.APP_NAME == 'senso' ? '/static/test-icon-start.png' : '/static/test-icon-start-improve.png'" />
                    </v-btn>
                  </v-col>
                  <v-col cols="5">
                    <v-card-text class="start-test-txt">
                      <div>Test failed. You scored {{ user.test_score }}%</div>
                    </v-card-text>
                  </v-col>
                  <v-col cols="3" class="test-btn-wrapper">
                    <v-btn class="" @click="showTest"> Take test again </v-btn>
                  </v-col>
                  <v-col cols="3" class="pr-10 test-btn-wrapper" style="justify-content: end">
                    <v-btn class="t" :to="'/courses/test/log/' + id + '/' + user.id">
                      View Result
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
            <div v-else>
              <div v-if="showTestButton" style="
                  background-color: #3497c5;
                  border-radius: 4px;
                  padding: 0 22px 0 22px;
                ">
                <!-- Small Screen -->
                <v-row v-if="this.screenSize === 'mobile'">
                  <v-col style="padding-top: 0; padding-bottom: 0">
                    <div style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 1rem;
                      ">
                      <v-btn icon class="test-start-icon">
                        <img
                          :src="$globalConfig.APP_NAME == 'senso' ? '/static/test-icon-start.png' : '/static/test-icon-start-improve.png'" />
                      </v-btn>

                      <div class="start-test-txt">
                        When you’re ready, take the test
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="this.screenSize === 'mobile'" class="pb-3 pt-3" no-gutters>
                  <v-col style="
                      display: flex;
                      justify-content: center;
                      padding-top: 0;
                      padding-bottom: 0;
                    " class="test-btn-wrapper">
                    <v-btn @click="showTest"> Start Test </v-btn>
                  </v-col>
                </v-row>

                <v-card-actions v-if="
                    this.screenSize === 'desktop' ||
                    this.screenSize === 'tablet'
                  " class="pa-0">
                  <v-spacer></v-spacer>

                  <v-btn icon class="test-start-icon">
                    <img
                      :src="$globalConfig.APP_NAME == 'senso' ? '/static/test-icon-start.png' : '/static/test-icon-start-improve.png'" />
                  </v-btn>

                  <v-card-text class="start-test-txt">
                    <div>When you’re ready, take the test</div>
                  </v-card-text>

                  <div class="test-btn-wrapper">
                    <v-btn class="" @click="showTest"> Start Test </v-btn>
                  </div>
                </v-card-actions>
              </div>
              <div v-else style="
                  background-color: #bdbdbd;
                  border-radius: 4px;
                  padding: 0 22px 0 22px;
                ">
                <!-- Small Screen -->
                <v-row v-if="this.screenSize === 'mobile'">
                  <v-col style="padding-top: 0; padding-bottom: 0">
                    <div style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 1rem;
                      ">
                      <v-btn icon>
                        <img src="/static/test-icon.png" />
                      </v-btn>

                      <div class="start-test-txt">
                        You will need to access all the course content before
                        taking the test
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="this.screenSize === 'mobile'">
                  <v-col style="
                      display: flex;
                      justify-content: center;
                      padding-top: 0;
                      padding-bottom: 0;
                    ">
                    <v-btn color="primary" disabled class="ma-3">
                      Take Test
                    </v-btn>
                  </v-col>
                </v-row>

                <v-card-actions v-if="
                    this.screenSize === 'desktop' ||
                    this.screenSize === 'tablet'
                  " class="pa-0">
                  <v-btn icon>
                    <img src="/static/test-icon.png" />
                  </v-btn>

                  <v-card-text class="start-test-txt">
                    <div>
                      You will need to access all the course content before
                      taking the test
                    </div>
                  </v-card-text>

                  <v-btn color="primary" disabled class="ma-3">
                    Take Test
                  </v-btn>
                </v-card-actions>
              </div>
            </div>
          </v-card>
          <v-card v-if="complete" flat style="width: 100%" class="text-xs-center">
            <div style="
                background-color: #f8b464;
                border-radius: 4px;
                padding: 0 22px 0 22px;
              ">
              <v-row v-if="this.screenSize === 'mobile'">
                <v-col style="padding-top: 0; padding-bottom: 0">
                  <div style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      gap: 1rem;
                    ">
                    <v-btn icon>
                      <img src="/static/test-passed-icon.png" />
                    </v-btn>

                    <div class="congratulation-txt">
                      Congratulations, you’ve completed this course
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="this.screenSize === 'mobile'">
                <v-col style="display: flex; justify-content: center; padding-top: 0">
                  <v-btn class="download-certificate-btn download-certificate-txt" text style="float: right"
                    @click="downloadCertificate">
                    Download Certificate
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Medium and Large Screen -->
              <v-card-actions class="pa-0" v-if="
                  this.screenSize === 'desktop' || this.screenSize === 'tablet'
                ">
                <v-col cols="1" class="pr-0">
                  <v-btn icon>
                    <img src="/static/test-passed-icon.png" />
                  </v-btn>
                </v-col>
                <v-col cols="6" class="pl-0">
                  <v-card-text class="congratulation-txt">
                    <div>Congratulations, you’ve completed this course</div>
                  </v-card-text>
                </v-col>
                <v-col cols="5">
                  <v-btn class="download-certificate-btn download-certificate-txt" text style="float: right"
                    @click="downloadCertificate">
                    Download Certificate
                  </v-btn>
                </v-col>
              </v-card-actions>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" class="mb-5" v-if="contentLoading">
        <v-col md="8">
          <h2 class="mb-2 font-20">Course Content</h2>
          <v-list-item style="border: 1px solid #ccc;">
            <div class="skeleton-box" style="width: 50px; height: 24px;"></div>
            <div class="skeleton-box ml-5" style="width: 50px; height: 24px;"></div>
          </v-list-item>
          <v-list-item v-for="index in 4" :key="index" style="border: 1px solid #ccc;">
            <div class="skeleton-box notification-state-box" style="width: 25px; height: 24px;"></div>
            <div class="skeleton-box notification-state-box" style="width: 25px; height: 24px;"></div>
            <v-list-item-content>
              <div class="skeleton-box" style="width: 70%; height: 16px;"></div>
            </v-list-item-content>
            <v-list-item-action style="align-items: center;">
              <div class="skeleton-box" style="width: 60px; height: 30px;"></div>
            </v-list-item-action>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="!contentLoading &&
          (hasVideos ||
          externalLink ||
          course.documents.data.length > 0 ||
          isPpt ||
          isScorm)
        ">
        <v-col md="8">
          <h2 class="mb-2 font-20">Course Content</h2>
          <v-card class="mb-5 vcard-border">
            <v-list two-line class="pb-0">
              <v-list-item-group>
            
              <v-list-item two-line class="videoitem-content-th">
                <template class="vcard-list">
                  <v-list-item-title style="width: 135px; flex: none">
                    Status
                  </v-list-item-title>
                  <v-list-item-title style="text-align: left">
                    Title
                  </v-list-item-title>
                  <v-list-item-title> &nbsp; </v-list-item-title>
                </template>
              </v-list-item>
          </v-list-item-group>
          </v-list>
          <SupplementalDocumentation></SupplementalDocumentation>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import { EventBus } from '@/event-bus.js';
import SupplementalDocumentation from '@/pages/authenticated/courses/SupplementalDocumentation';
import Test from '@/components/authenticated/courses/Test';
import VideoPlayer from '@/pages/authenticated/courses/VideoPlayer';
import courseAPI from '@/api/course.js';
import PptPlayer from '@/pages/authenticated/courses/PptPlayer';
import ScormPlayer from '@/pages/authenticated/courses/ScormPlayer';
import eventAPI from "@/api/event.js";
import { screensize } from '../../../utils/screensize.js';

// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  name: 'CoursePlayer',
  components: {
    LayoutBasic,
    SupplementalDocumentation,
    VideoPlayer,
    PptPlayer,
    ScormPlayer,
  },
  data() {
    return {
      completed: false,
      deadlinePassed: false,
      eventType: 1,
      loading: false,
      totalEvents: 0,
      id: this.$route.params.id,
      screenSize: currentScreenSize,
      params:
        '?include=thumbnail,enrolled,videos,documents,test,links,ppts,scorm',
      links: [],
      ppts: [],
      scorm: [],
      noCourseFound: false,
      progressLists: '',
      suspendedData: '',
      contentLoading: false
    };
  },
  computed: {
    complete: function () {
      return this.user.state == 3 ? true : false;
    },
    completeWithOutTest: function () {
      return this.user.state == 5 ? true : false;
    },
    inProgress: function () {
      return this.user.state == 2 ? true : false;
    },
    notStarted: function () {
      return this.user.state == 1 ? true : false;
    },
    progress: function () {
      return this.user.progress;
    },
    totalVideos: function () {
      return this.course.total_videos;
    },
    totalWatchedVideos: function () {
      return this.$store.getters.userStats.watched.data.length;
    },
    completedEvents: function () {
      return null;
    },
    multiVideo: function () {
      return this.course.videos.data.length > 1 ? true : false;
    },
    externalLink: function () {
      return this.course.links.data.length > 0 ? true : false;
    },
    selectedVideo: function () {
      return this.$store.getters.currentVideo;
    },
    course: function () {
      return this.$store.getters.coursePlayer;
    },
    user: function () {
      return this.$store.getters.userStats;
    },
    deadline: function () {
      return this.$store.getters.userStats.deadline;
    },
    takeTest: function () {
      return this.completeWithOutTest && this.course.has_test ? true : false;
    },
    hasTest: function () {
      return this.course.has_test ? true : false;
    },
    showTestButton: function () {
      return this.user.state == 5 ? true : false;
    },
    entity: function () {
      return {
        related_entity: this.$store.getters.coursePlayer.id,
        related_entity_asset_id: this.selectedVideo.id,
        entity_lookup_user_id: this.$store.getters.userStats.id,
        entity_type: 1, //course
      };
    },
    duration: function () {
      if (this.course.hours != 0) {
        return this.course.hours * 60 + this.course.minutes;
      } else {
        return this.course.minutes;
      }
    },
    selectedPpt: function () {
      return this.$store.getters.currentPpt;
    },
    isPpt: function () {
      return this.course.ppts.data.length > 0 ? true : false;
    },
    hasVideos: function () {
      if (
        this.course.videos != null &&
        this.course.videos.hasOwnProperty('data') &&
        this.course.videos.data.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    isScorm: function () {
      return this.course.scorm.data.length > 0 ? true : false;
    },
  },
  mounted() {
    this.getCourse(this.id);
    this.$store.dispatch('setPlayVideo', false);
    this.setEventBus();
    this.handleResize();

    // Add event listener for screen size changes
    window.addEventListener('resize', this.handleResize);
    window.addEventListener("message", this.handleMessage, false);
  },
  watch: {
    // Watch for changes in the route's id
    '$route.params.id'(newId) {
      this.id = newId;
      this.getCourse(newId);
      EventBus.$emit('DRAWER_STATE', false);
    },
  },
  methods: {
    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },
    getCourse() {
      this.loading = true;
      courseAPI
        .getCourse(this.id, this.params)
        .then((response) => {
          this.progressLists =  response.data.data.enrolled.data.scormprogress.data;
          this.setScormProgress()
          this.links = response.data.data.links.data;
          this.ppts = response.data.data.ppts.data;
          this.scorm = response.data.data.scorm.data;
          this.$store.dispatch('setCoursePlayer', response.data.data);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.noCourseFound = true;
        });
    },
    downloadCertificate() {
      if (!this.user.certificate_url) {
        alert('No certificate is available for this course. Please contact your administrator.');
        return;
      }
      window.open(this.user.certificate_url, '_blank');
    },
    showTest() {
      this.$showPanel({
        component: Test,
        props: {
          course: this.course,
        },
        openOn: 'right',
      });
    },
    setEventBus() {
      EventBus.$on('ANSWERS_SUBMITTED', (payload) => {
        this.loading = true;
        courseAPI
          .getCourse(payload.data.data.course_id, this.params)
          .then((response) => {
            this.loading = false;
            this.$store.dispatch('setCoursePlayer', response.data.data);
          });
      });
    },
    handleLinkClick(event) {
      // Check if the clicked element is a link
      if (
        event.target.tagName === 'A' ||
        event.target.parentElement.tagName === 'A'
      ) {
        // Prevent the default action of the click event
        event.preventDefault();
        // Get the link URL
        const linkUrl =
          event.target.tagName === 'A'
            ? event.target.href
            : event.target.parentElement.href;
        // Open the link URL in a new tab
        window.open(linkUrl, '_blank');
      }
    },
    getLatestCourseInfo() {
      this.contentLoading = true;
      courseAPI
        .getCourse(this.id, '?include=enrolled,videos,documents,test,links,ppts,scorm')
        .then((response) => {
          this.progressLists =  response.data.data.enrolled.data.scormprogress.data;
          this.setScormProgress()
          this.$store.dispatch(
            'setUserStats',
            response.data.data.enrolled.data
          );
          this.$store.dispatch('setCoursePlayer', response.data.data);
          EventBus.$emit('WATCHED_ASSETS');
          this.contentLoading = false;
        });
    },
    setScormProgress(){
    this.progressLists.forEach(progress => {
        if (progress.asset_id) {
          const dataToStore = {
            suspend_data: progress.suspend_data,
            lesson_location: progress.lesson_location,
          };

          localStorage.setItem(progress.asset_id, JSON.stringify(dataToStore));
          console.log(`✅ Saved SCORM progress for asset_id: ${progress.asset_id}`, dataToStore);
        }
      });

    },
     handleMessage(event) {
      const message = event.data;

      if (message.type === "GET_SCORM_PROGRESS") {
        const stored = localStorage.getItem(message.assetId);
        event.source.postMessage(
          {
            type: "SCORM_PROGRESS_RESPONSE",
            assetId: message.assetId,
            data: stored ? JSON.parse(stored) : null,
          },
          event.origin
        );
      }

      if(message.type === "UPDATE_SCORM_PROGRESS"){
        // if(this.suspendedData != message.lastSuspendData){
          eventAPI.updateSuspendedData(message).then((response) => {
              console.log(' 📥 response ', response)
              this.getLatestCourseInfo();
          });
          console.log(' 📥 UPDATE_SCORM_PROGRESS ', message)
        // }
      // this.suspendedData = message.lastSuspendData;
      }

      if(message.type === 'COMPLETE_SCORM'){
        eventAPI.markScormAsCompleted(message).then((response) => {
            this.getLatestCourseInfo();
          });
        console.log(' 📥 COMPLETE_SCORM ', message)
      }
    },
  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener("message", this.handleMessage, false);
    this.screenSize = null;
    if(this.progressLists){
    this.progressLists.forEach(progress => {
        if (progress.asset_id) {
          localStorage.removeItem(progress.asset_id);
        }
      });
    }
  },
}; 
</script>
